angular.module("UI8.components").component("inboxThread", {
  template: `<div class="inbox inbox--thread">
      <div class="container">
        <div class="inbox__head" ng-if="$ctrl.thread">
          <a class="inbox__back" href="/account/inbox" aria-label="Back to inbox">
            <svg viewBox="0 0 16 16"><path d="M10.7 2.3a1 1 0 0 1 0 1.4L6.4 8l4.3 4.3a1 1 0 1 1-1.4 1.4l-5-5a1 1 0 0 1 0-1.4l5-5a1 1 0 0 1 1.4 0z"/></svg>
          </a>
          <a class="inbox__who" ng-href="/users/{{ $ctrl.thread.other.slug }}">
            <div class="inbox__avatar">
              <img ng-if="$ctrl.thread.other.avatar_url" ng-src="{{ $ctrl.thread.other.avatar_url }}" alt="{{ $ctrl.thread.other.name }}">
              <div class="inbox__initial" ng-if="!$ctrl.thread.other.avatar_url">{{ $ctrl.thread.other.name.charAt(0) }}</div>
            </div>
            <div class="inbox__name">
              {{ $ctrl.thread.other.name }}
              <span class="hchip hchip--founding" ng-if="$ctrl.thread.other.badge === 'founding'">Founding Member</span>
              <span class="hchip" ng-if="$ctrl.thread.other.badge === 'verified'">Verified</span>
            </div>
          </a>
          <button class="inbox__block" ng-click="$ctrl.toggleBlock()">{{ $ctrl.thread.blocked ? "Unblock" : "Block" }}</button>
        </div>

        <div class="inbox__brief" ng-if="$ctrl.thread.brief && ($ctrl.thread.brief.project_type || $ctrl.thread.brief.budget_range || $ctrl.thread.brief.timeline)">
          <span ng-if="$ctrl.thread.brief.project_type">{{ $ctrl.thread.brief.project_type }}</span>
          <span ng-if="$ctrl.thread.brief.budget_range">{{ $ctrl.thread.brief.budget_range }}</span>
          <span ng-if="$ctrl.thread.brief.timeline">{{ $ctrl.thread.brief.timeline }}</span>
        </div>

        <div class="inbox__messages" ng-if="$ctrl.messages.length">
          <div class="inbox__message" ng-repeat="m in $ctrl.messages track by m._id" ng-class="{mine: m.mine}">
            <div class="inbox__bubble">{{ m.body }}</div>
            <div class="inbox__stamp" ng-if="$last || !$ctrl.messages[$index + 1] || $ctrl.messages[$index + 1].mine !== m.mine">{{ m.created_at | relativeDate }}</div>
          </div>
        </div>

        <div class="inbox__reply" ng-if="$ctrl.thread && !$ctrl.thread.blocked">
          <textarea class="field__textarea" ng-model="$ctrl.draft" placeholder="Write a reply..." ng-keydown="$ctrl.keydown($event)"></textarea>
          <div class="inbox__replyfoot">
            <span class="inbox__replyhint">⌘ + Enter to send</span>
            <button class="btn inbox__send" ng-if="!$ctrl.sending" ng-disabled="!$ctrl.draft" ng-click="$ctrl.send()">Send</button>
            <div class="loader loader--small" ng-if="$ctrl.sending"></div>
          </div>
        </div>
        <div class="inbox__closed" ng-if="$ctrl.thread.blocked">This conversation is blocked.</div>

        <div class="inbox__empty" ng-if="!$ctrl.thread && !$ctrl.loading">
          <p>Conversation not found.</p>
        </div>
      </div>
    </div>`,

  controller: function (HireService, FlashService, $scope) {
    var ctrl = this;

    ctrl.loading = true;
    ctrl.messages = [];
    ctrl.draft = "";
    ctrl.sending = false;

    ctrl.$onInit = function () {
      HireService.thread(ctrl.threadId).then(function (res) {
        ctrl.loading = false;
        if (res && res.thread) {
          ctrl.thread = res.thread;
          ctrl.messages = res.messages || [];
        }
        $scope.$applyAsync();
        scrollToEnd();
      });
    };

    // Only chase the bottom when the conversation is actually taller than
    // the viewport — otherwise a two-message thread scrolls the reader
    // into empty space for no reason.
    function scrollToEnd() {
      setTimeout(function () {
        if (document.body.scrollHeight > window.innerHeight + 40) {
          window.scrollTo(0, document.body.scrollHeight);
        }
      }, 50);
    }

    ctrl.send = function () {
      var body = (ctrl.draft || "").trim();
      if (!body || ctrl.sending) return;
      ctrl.sending = true;

      HireService.reply(ctrl.thread._id, body).then(function (res) {
        ctrl.sending = false;
        if (!res || res.error) {
          FlashService.set(
            "error",
            (res && res.error) || "Unable to send message"
          );
        } else {
          ctrl.messages.push(res.message);
          ctrl.draft = "";
          scrollToEnd();
        }
        $scope.$applyAsync();
      });
    };

    ctrl.keydown = function ($event) {
      if ($event.keyCode === 13 && ($event.metaKey || $event.ctrlKey)) {
        $event.preventDefault();
        ctrl.send();
      }
    };

    ctrl.toggleBlock = function () {
      HireService.block(ctrl.thread._id).then(function (res) {
        if (res && typeof res.blocked === "boolean")
          ctrl.thread.blocked = res.blocked;
        $scope.$applyAsync();
      });
    };
  },

  bindings: {
    threadId: "<",
    user: "<",
  },
});
